import React from 'react';
import { styled, Link } from '@mui/material';
import { getCallCenterLink } from 'utils';

const CallCenter = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
})) as typeof Link;

export const CallCenterLink = () => {
  const { tel, fullPhone } = getCallCenterLink();
  return (
    <CallCenter variant="subtitle2" href={`tel:${tel}`}>
      {fullPhone}
    </CallCenter>
  );
};
